import { Component, OnInit } from '@angular/core';
import { ServiceMangeService } from 'src/app/services/service-mange.service';
import { MatDialog } from '@angular/material/dialog';
import { AddMicroServiceComponent } from '../add-micro-service/add-micro-service.component';
import { AddServiceComponent } from '../add-service/add-service.component';
import { MainService } from 'src/app/services/main.service';
import { timeSaturday } from 'd3-time';
import { EditServiceComponent } from '../edit-service/edit-service.component';
import { DatePipe } from '@angular/common';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ThemePalette } from '@angular/material/core';

@Component({
  selector: 'app-all-services',
  templateUrl: './all-services.component.html',
  styleUrls: ['./all-services.component.css']
})
export class AllServicesComponent implements OnInit {

  array = new Array(9)
  list_serives: any
  microServiceList: any = []
  ServiceName: any = ''
  serivceId: any
  seriveItem: any
  add_serviceStatus = true
  pipe = new DatePipe('en-US')
  suchdelFrom: FormGroup | any;
  dates_arry :any = []
  disabledApp= false
  color: ThemePalette = "primary";
  constructor(private rest: ServiceMangeService,
    public dialog: MatDialog,
    private main: MainService
  ) { }

  ngOnInit() {
    const date1 = new Date('2023-08-09');
    const date2 = new Date('2023-08-30');
    this.suchdelFrom = new FormGroup({
      duration: new FormControl("", [Validators.required]),
      capacity: new FormControl("", [Validators.required]),
      valid_from: new FormControl("", [Validators.required]),
      valid_to: new FormControl("", [Validators.required]),
    })
    // let allDates = this.getDatesBetween(date1, date2);
    this.all_services()
  }
  getDatesBetween(startDate: any, endDate: any , capacity:any , duration:any) {
    let endTime = this.pipe.transform(new Date(endDate), 'HH:mm:ss')
    let startTime = this.pipe.transform(new Date(startDate), 'HH:mm:ss')

    const currentDate = new Date(startDate.getTime());
    while (currentDate <= endDate) {
      let datee = this.pipe.transform(new Date(currentDate), 'YYYY-MM-dd')
      this.dates_arry.push({
        "valid_from": `${datee} ${startTime}`  ,
        "valid_to": `${datee} ${endTime}`,
        "duration": duration,
        "capacity": capacity
      });
      currentDate.setDate(currentDate.getDate() + 1);
    }
    console.log(this.dates_arry)
    this.addSucdleServ()
  }

  all_services() {
    this.rest.allServices().subscribe((res: any) => {
      console.log(res)
      this.list_serives = res
      this.list_serives.forEach((element: any) => {
        element.status = false
        if (element.image == '') {
          element.image = 'assets/images/serivces/1.png'
        }
      });
      this.serviceDetails(res[0])
      this.seriveItem = res[0]
      this.ServiceName = res[0].name
      this.serivceId = res[0].id
      this.list_serives[0].status = true
    })
  }

  serviceObject:any

  serviceDetails(item: any) {
    this.serviceObject = item
    this.list_serives.forEach((element: any) => {
      if (element.id == item.id) {
        element.status = true
      } else {
        element.status = false
      }
    });
    this.seriveItem = item
    this.ServiceName = item.name
    this.serivceId = item.id
    this.rest.mircoService(item.id).subscribe((res: any) => {
      console.log(res)

      if (res.error_reason) {
        this.microServiceList = []
      } else {
        this.microServiceList = res
        this.microServiceList.forEach((element: any) => {
          if (element.image == '') {
            element.image = "assets/images/avatar.png"
          }

          if (!element.cost) {
            element.cost = 0
          }

        });
      }
    })
  }

  addMicroService() {
    const dialogRef = this.dialog.open(AddMicroServiceComponent, {
      width: "400px",
      data: { name: this.ServiceName }
    });

    dialogRef.afterClosed().subscribe((res: any) => {
      console.log(res)
      if (res) {
        res.type_id = this.serivceId

        this.rest.addMicro_service(res).then(response => response.text())
          .then((result: any) => {
            console.log()
            let res = JSON.parse(result)
            if (res.message == 'Service Name Exists!') {
              this.main.erorrToast("Micro Service Name Exists!")
            } else {
              this.main.SuccessToast("Micro service added successfully")
              this.serviceDetails(this.seriveItem)
            }


          })
          .catch(error => console.log('error', error));
      }
    })
  }

  addService() {
    this.add_serviceStatus = false
    this.serviceName = '',
      this.serviceImage = ''
    // const dialogRef = this.dialog.open(AddServiceComponent ,{
    //   width : "400px",
    // });

    // dialogRef.afterClosed().subscribe((res:any) => {
    //   console.log(res)
    //   if(res){
    //     this.rest.add_service(res).then(response => response.text())
    //     .then(result => console.log(result))
    //     .catch(error => {
    //       this.main.erorrToast("Opss somthing worng happen!")
    //     });
    //   }
    // })
  }

 
  back() {
    this.add_serviceStatus = true
    this.schedules_status = false
    this.edit_serviceStatus = false
    this.schudleEdit = false
  }

  // add service 
  serviceName = ""
  serviceImage = ""
  schedules_status = false
  uploadServiceImage(e: any) {
    console.log(e.target.value)
    this.serviceImage = e.target.files[0]
  }

 service_Id:any 
  next() {
    let data = {
      name: this.serviceName,
      image: this.serviceImage
    }
    console.log(data)
    this.rest.add_service(data).then(response => response.text())
      .then(result => {
        console.log(result)
        this.service_Id = result
        this.schedules_status = true

        let data2 = {
          id : result,
          disabled : this.disabledApp
        }
        this.rest.disableSerives(data2).subscribe((res:any) => {
          console.log(res)
        })

      })
      .catch(error => {
        this.main.erorrToast("Opss somthing worng happen!")
      });

      
  }

  addServices() {
    // this.back()
    console.log(this.suchdelFrom.value)
    let data = this.suchdelFrom.value
    data.valid_from = new Date(data.valid_from);
    data.valid_to = new Date(data.valid_to);

    this.getDatesBetween(data.valid_from, data.valid_to,data.capacity,data.duration);
  }

  addSucdleServ(){
    let data = {
      service_id : this.service_Id,
      schedules : this.dates_arry
    }
    if(this.edit_serviceStatus == true){
      this.rest.add_Service_Schedules(data).subscribe((res:any) => {
        console.log(res)
        this.main.SuccessToast("service Edit successfully")
        this.ngOnInit()
        this.back()
      })
    }else {
      this.rest.add_Service_Schedules(data).subscribe((res:any) => {
        console.log(res)
        this.main.SuccessToast("service added successfully")
        this.ngOnInit()
        this.back()
      })
    }
 
  }

  // delet service

  deleteService(value?:any){
    if(value){

    }else {
       value = this.serviceObject
    }
    console.log(value)
  }

  // edit service 

  edit_serviceStatus = false
  serviceNameEdit = ""
  serviceImageEdit = ""
  serviceId = ''
  imageUplaoded = ''
  servicCost = ''
  editMicroService(item?: any) {
    if(item){
    }else {
      item = this.serviceObject
    }
    this.edit_serviceStatus = true
    this.add_serviceStatus = false
    this.serviceNameEdit = item.name
    this.serviceImageEdit = item.image
    this.serviceId = item.id
    if(item.cost){
      this.servicCost = item.cost
    }else {
      this.servicCost = ''
    }
    console.log(item)
  }
  
  uploadServiceImageEdit(e:any){
    console.log(e.target.value)
    this.imageUplaoded = e.target.files[0]
  }
  deletImage(){
    this.serviceImageEdit = ''
  }

  schudleEdit = false
  EditService(){
    this.service_Id = this.serviceId
    let data:any ;
    if(this.imageUplaoded != ''){
      data = {
        name : this.serviceNameEdit,
        image : this.imageUplaoded,
        service_id : this.serviceId
      }
    }else {
      data = {
        name : this.serviceNameEdit,
        service_id : this.serviceId
      }
    }

    if(this.servicCost != ''){
      data.cost = this.servicCost
    }

    this.rest.edit_service(data).then(response => response.text())
    .then((result: any) => {
      console.log(result)
      let res = JSON.parse(result)
      if (res.message == 'Service Name Exists!') {
        this.main.erorrToast(" Service Name Exists!")
      } else {
        // 
        if(this.servicCost != ''){
          this.main.SuccessToast("service edit successfully")
          this.all_services()
        }else {
          this.schudleEdit = true
          let data = {
            id : this.serviceId,
            disabled : this.disabledApp
          }
          this.rest.disableSerives(data).subscribe((res:any) => {
            console.log(res)
          })
        }
        // 
      }


    })
    .catch(error => console.log('error', error));
  }
}
